(function () {
  if (window.__deliveryTimelineLoaded) return;
  window.__deliveryTimelineLoaded = true;

  var ICON_CART = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/></svg>';
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-9l1.96 2.5H17V9.5h2.5zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4z"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>';

  var MONTHS_FR = ['Jan','Fev','Mar','Avr','Mai','Juin','Juil','Aout','Sept','Oct','Nov','Dec'];

  var TOOLTIPS = {
    order: 'Votre commande est confirmée immédiatement après l’achat',
    ship: 'Votre colis est préparé puis remis au transporteur',
    delivered: 'Date estimée de réception à votre adresse'
  };

  function fmt(d) {
    var day = ('0' + d.getDate()).slice(-2);
    return day + ' ' + MONTHS_FR[d.getMonth()];
  }

  function esc(s) {
    var div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  function buildTimelineHTML() {
    var today = new Date();
var ship = new Date(today.getTime()); ship.setDate(ship.getDate() + 2);
var delivered = new Date(today.getTime()); delivered.setDate(delivered.getDate() + 9);

    return (
      '<div class="delivery-timeline">' +
        '<div class="delivery-timeline__step">' +
          '<div class="delivery-timeline__icon" tabindex="0" data-tooltip="' + esc(TOOLTIPS.order) + '">' + ICON_CART + '</div>' +
          '<p class="delivery-timeline__date">' + fmt(today) + '</p>' +
          '<p class="delivery-timeline__label">Commandée</p>' +
        '</div>' +
        '<div class="delivery-timeline__connector"></div>' +
        '<div class="delivery-timeline__step">' +
          '<div class="delivery-timeline__icon" tabindex="0" data-tooltip="' + esc(TOOLTIPS.ship) + '">' + ICON_TRUCK + '</div>' +
          '<p class="delivery-timeline__date">' + fmt(ship) + '</p>' +
          '<p class="delivery-timeline__label">Expédiée</p>' +
        '</div>' +
        '<div class="delivery-timeline__connector"></div>' +
        '<div class="delivery-timeline__step">' +
          '<div class="delivery-timeline__icon" tabindex="0" data-tooltip="' + esc(TOOLTIPS.delivered) + '">' + ICON_CHECK + '</div>' +
          '<p class="delivery-timeline__date">' + fmt(delivered) + '</p>' +
          '<p class="delivery-timeline__label">Livrée</p>' +
        '</div>' +
      '</div>'
    );
  }

  function findAnchor() {
    return (
      document.querySelector('product-form .product-form__buttons') ||
      document.querySelector('.product-form__buttons') ||
      document.querySelector('#productMainSubmit') ||
      document.querySelector('button[name="add"]')
    );
  }

  function insertTimeline() {
    if (document.querySelector('.delivery-timeline')) return;
    if (!/\/products\//.test(window.location.pathname)) return;

    var anchor = findAnchor();
    if (!anchor) return;

    var container =
      (anchor.closest && (anchor.closest('product-form') || anchor.closest('.product-form'))) ||
      anchor.parentElement;
    if (!container || !container.parentNode) return;

    var wrapper = document.createElement('div');
    wrapper.innerHTML = buildTimelineHTML();
    container.parentNode.insertBefore(wrapper.firstElementChild, container.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insertTimeline);
  } else {
    insertTimeline();
  }
  document.addEventListener('shopify:section:load', insertTimeline);
})();
